var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useId } from 'react';
import { ColorPicker } from '../ui';
import { FormField } from './form-field';
export var ColorPickerField = function (_a) {
    var label = _a.label, error = _a.error, description = _a.description, width = _a.width, _b = _a.labelClassName, labelClassName = _b === void 0 ? '' : _b, tooltip = _a.tooltip, props = __rest(_a, ["label", "error", "description", "width", "labelClassName", "tooltip"]);
    var id = useId();
    return (_jsx(FormField, { label: label, error: error, description: description, htmlFor: id, labelVariant: 'label', width: width, labelClassName: labelClassName, tooltip: tooltip, containerClassName: width !== null && width !== void 0 ? width : 'w-full', children: _jsx(ColorPicker, __assign({ id: id }, props)) }));
};
